import PatientDashboard from "./Components/PatientDashboard";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser"
import MsalLoadingComponent from "../../Components/Msal/MsalLoadlingComponent"
import MsalErrorComponent from "../../Components/Msal/MsalErrorComponent"
import NotAuthorized from '../../Components/NotAuthorized';

interface Props {
    className?: string,
}

const Registered = ({className}: Props) => {

  sessionStorage.setItem('post-login-redirect-url',  `${window.location.origin}/registered`);
  return (
	<MsalAuthenticationTemplate 
		interactionType={InteractionType.Redirect}
		errorComponent={NotAuthorized}
		loadingComponent={MsalLoadingComponent}
		authenticationRequest={{state: `${window.location.origin}/registered`}}
	>
    	<div>
      		<PatientDashboard />
	   	</div>
	</MsalAuthenticationTemplate>
  );
};

export default Registered;
